import { defineSlotRecipe } from '@chakra-ui/react';

export const popoverSlotRecipe = defineSlotRecipe({
  className: 'chakra-popover',
  slots: ['root', 'content', 'body'],
  base: {
    root: {
      pointerEvents: 'auto',
    },
    content: {
      pointerEvents: 'auto',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      textStyle: 'sm',
      '--popover-bg': 'transparent',
      backgroundColor: 'transparent',
      borderRadius: 'none',
      _open: {
        animationStyle: 'scale-fade-in',
        animationDuration: 'fast',
      },
      _closed: {
        animationStyle: 'scale-fade-out',
        animationDuration: 'faster',
      },
    },
    body: {
      border: '2px solid',
      borderColor: 'transparent',
      padding: 'var(--popover-padding)',
      flex: '1',
      pointerEvents: 'auto',
      touchAction: 'auto',
      display: 'flex',
      justifyContent: 'center',
    },
  },
});
